// src/app/services/building.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, retry, throwError, timer } from 'rxjs';
import { Building } from '../models/building.model'; 
import { environment } from '../../../environments/environment.dev';

const API_URL = environment.API_URL + '/buildings';

@Injectable({
  providedIn: 'root'
})
export class BuildingService {

  constructor(private http: HttpClient) {}

  findAll(): Observable<Building[]> {
    return this.http.get<Building[]>(API_URL);
  }

  findById(id: number): Observable<Building | null> {
    return this.http.get<Building>(`${API_URL}/${id}`).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 404) {
          return of(null);
        }
        return throwError(() => err);
      })
    );
  }

  getMyBuildings(): Observable<Building[]> {
    return this.http.get<Building[]>(`${API_URL}/my`).pipe(
      retry({
        count: 2,
        delay: (error: HttpErrorResponse, retryCount) => {
          if (this.isTransientListError(error)) {
            return timer(retryCount * 700);
          }
          throw error;
        },
      })
    );
  }

  addBuilding(building: Building): Observable<Building> {
    return this.http.post<Building>(API_URL, building);
  }

  getMyCreatedBuildings(): Observable<Building[]> {
    return this.http.get<Building[]>(`${API_URL}/created`).pipe(
      catchError((_) => of([])) 
    );
  }

  private isTransientListError(error: HttpErrorResponse): boolean {
    return error instanceof HttpErrorResponse
      && [0, 408, 429, 500, 502, 503, 504].includes(error.status);
  }
}
